import axios from 'axios';
import { CONSTS } from './endpoints';
import { getCookie } from './tools';

const getAuthToken = () => {
  return getCookie(CONSTS.AUDIENCE_TOKEN);
}

const headers = {
  'Content-Type': 'application/json',
  'Accept': 'application/json',
  'Authorization': `Bearer ${getAuthToken()}`
};

export const http_post = (url, data = {}, params = {}) => {
  return axios.post(url, data, {
    headers: headers,
    params
  });
};

// submit progress on learning material
export const submitProgress = (data) => {
  return http_post(CONSTS.PROGRESS, data);
};